import { render, staticRenderFns } from "./reprint.vue?vue&type=template&id=d81c5f2a"
import script from "./reprint.vue?vue&type=script&lang=ts"
export * from "./reprint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports